<template>
  <div>
    <auto-form v-model="fields" :mode="mode"></auto-form>
  </div>
</template>

<script>

import AutoForm from '../../../components/CommonView/AutoForm.vue';
import * as moment from "moment/moment";
import { view } from './header'
export default {
  props: {
    item: {
      type: Object
    },
    mode: {
      type: String,
      default: 'view'
    }
    
  },
  components: {
    AutoForm
  },
  computed: {
    fields: {
      get() {
        return [
          // {name: 'id', label:'Id', type: 'text-field', value: this.item?.id, readonly: true, hideOnCreate: true, cols: 6 },
          {name: 'type', label:'Phân loại', type: 'autocomplete', value: this.item?.type, cols: 12, items: ['SECTION', 'SUBHEADER', 'MENU', 'GROUP'] },
          {name: 'title', label:'Tiêu đề', type: 'text-field', value: this.item?.title, cols: 12 },
          {name: 'icon', label:'Icon', type: 'text-field', value: this.item?.icon, cols: 12 },
          {name: 'parentId', label:'Nhóm', type: 'text-field', value: this.item?.parentId, cols: 12 },
          {name: 'claims', label:'Phân quyền', type: 'text-field', value: this.item?.claims, cols: 12 },
          {name: 'routeName', label:'Route', type: 'text-field', value: this.item?.routeName, cols: 12 },
          // {name: 'monthNo', label:'Tháng', type: 'text-field', value: this.item?.monthNo, cols: 12, md:6 },
          // {name: 'body', label:'Chi tiết', type: 'textarea', value: this.item?.body, cols: 12, md:12 },
        ]
      },
      set(value) {
        if(value) {
          this.$emit('input', value);
        }
      }
    },
    
    viewHeaders () {
      return view([])
    }
  },
  data() {
    return {
      // slots: ['score']
    }
  },
  watch: {
    item(newVal, oldVal) {
      console.log(newVal, oldVal)
    }
  },
  methods: {
  }

}
</script>